import React from 'react';
import EmailSignup from '../EmailSignup';

const AboutSection = () => {

  return (
    <div className="bg-[#D5BD5D] mt-6 md:rounded-xl p-8 mx-auto max-w-5xl mb-0 md:mb-16">
      <div className="flex flex-col md:flex-row gap-8">
        
        <div className="flex-1">
          <h3 className="text-2xl font-bold text-[#012F47]">About Livermore Odd Fellows</h3>
          <p className="text-lg mt-4 text-[#012F47]">
            The Livermore International Order of Odd Fellows, 
            Lodge Number 219 was established on May 23rd 1873. 
            The Livermore Odd Fellows Building was built the next year in 1874. 
            In July 1998 the City of Livermore recognized the Livermore Lodge as a 
            Historic Preservation Heritage Site.</p>
        </div>

        <div className="flex-1">
          <h3 className="text-2xl font-bold text-[#012F47]">Subscribe to our Newsletter:</h3>
          <EmailSignup />
            <p className="text-lg mt-6 italic text-[#012F47]">
            We are not currently sending newsletters but plan to in the future.</p>
        </div>

      </div>
    </div>
  )
}

export default AboutSection;